import { css } from 'styled-components';
import { media } from './breakpoints';

// Типографические токены (desktop) — повторяют текущий UI, чтобы миграция
// компонентов не меняла вид на десктопе.
export const FONT = {
  xs: '11px',          // сверхмелкие подписи, KPI-sub
  sm: '12px',          // бейджи, шапки таблиц, meta
  md: '13px',          // лейблы, ячейки, вторичный текст
  base: '14px',        // основной текст, кнопки
  lg: '15px',          // навигация
  xl: '16px',          // заголовки модалок, CTA
  xxl: '18px',         // логотип, заголовки секций
  pageTitle: '22px',   // заголовки страниц
  kpi: '28px',         // крупные числа на дашбордах
  hero: '64px',        // логотип на Home
};

// Мобильная шкала (≤640px) — текст крупнее для чтения на телефоне.
// base 16px и выше — также убирает auto-zoom iOS Safari при фокусе в поле.
export const FONT_MOBILE = {
  xs: '12px',
  sm: '13px',
  md: '14px',
  base: '16px',
  lg: '16px',
  xl: '17px',
  xxl: '19px',
  pageTitle: '22px',
  kpi: '28px',
  hero: '64px',
};

// Минимум для контролов на touch-ширинах (анти-iOS-зум).
export const CONTROL_TOUCH = '16px';

// Текст: десктопный размер + мобильный бамп на ≤640px.
// Используется только внутри styled-шаблонов, не в style={{}}.
export const font = (token = 'base') => css`
  font-size: ${FONT[token]};
  ${media.mobile`font-size: ${FONT_MOBILE[token]};`}
`;

// Контролы (input/select/textarea): десктопный размер + принудительно ≥16px
// на ≤1024px — чтобы iOS Safari не приближал страницу при фокусе (и на планшетах).
export const fontControl = (token = 'base') => css`
  font-size: ${FONT[token]};
  ${media.tablet`font-size: ${CONTROL_TOUCH};`}
`;
